import { useState } from 'react';

import useDelayedAction from '~/hooks/animations/useDelayedAction';

const useTemporalVisibility = (timeout: number) => {
  const [visible, setVisible] = useState(false);
  const { trigger } = useDelayedAction(timeout, () => setVisible(false));

  return {
    visible,
    show: () => {
      setVisible(true);
      trigger();
    },
  };
};

export default useTemporalVisibility;
